import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {MenuModel} from '../model/menu.model';

@Injectable()
export class MenuService {

  path = '/menu';

  constructor(private baseService: BaseService) { }

  get (idMenu: number) {
    return this.baseService.get(this.path, '/' + idMenu);
  }

  getPaginated(init: number, end: number) {
      return this.baseService.get(this.path, '', {init, end});
  }

  post(menu: MenuModel) {
      return this.baseService.post(this.path, '/', menu);
  }

  put(menu: MenuModel) {
      return this.baseService.put(this.path, '/', menu);
  }

  delete(idMenu: number) {
      return this.baseService.delete(this.path, '/' + idMenu);
  }

  save(menu: MenuModel) {
      if (menu.id) {
          return this.put(menu);
      } else {
          return this.post(menu);
      }
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/menu.service.ts